import React from 'react';
import { X, Tag } from 'lucide-react';
import type { Note } from '../../hooks/useNotes';

interface NoteViewerProps {
  content: Note['content'];
  tags?: string[];
  color: string;
  onClose: () => void;
  onTagClick: (tag: string) => void;
}

export function NoteViewer({
  content,
  tags = [], // Provide default empty array
  color,
  onClose,
  onTagClick,
}: NoteViewerProps) {
  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-start justify-center z-50 overflow-y-auto py-8">
      <div className="bg-[#2A2B2E] rounded-3xl p-6 max-w-4xl w-full mx-4 flex flex-col">
        <div className="flex justify-between items-center mb-6">
          <h3 className="text-xl">View Brain Dump</h3>
          <button
            onClick={onClose}
            className="p-2 hover:bg-black/20 rounded-full"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="space-y-4">
          <h2 className="text-2xl">{content.title}</h2>
          <div 
            className="p-6 rounded-xl whitespace-pre-wrap break-words text-lg"
            style={{ backgroundColor: color }}
          >
            {content.text}
          </div>

          {tags && tags.length > 0 && (
            <div className="flex flex-wrap gap-2 p-2 mt-4">
              {tags.map((tag) => (
                <button
                  key={tag}
                  onClick={() => onTagClick(tag)}
                  className="flex items-center gap-2 px-3 py-2 bg-black/20 rounded-lg text-sm hover:bg-black/30 transition-colors"
                >
                  <Tag className="w-4 h-4" />
                  {tag}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}